<section class="smoking-policy" data-testid="smoking-policy-section">
  <goab-text tag="h1" size="heading-xl" mt="xl" mb="s">
    Smoking policy
  </goab-text>

  <goab-text tag="p" size="body-m" mt="xl" mb="xl">
    Use this section to confirm whether your facility has a written smoking
    policy in place.
  </goab-text>

  <goab-spacer vSpacing="xs"></goab-spacer>

  <goab-text tag="h2" size="heading-xs" mt="none" mb="xs">
    What to select each week
  </goab-text>

  <goab-text tag="span" size="body-m" mt="none" mb="none">
    Yes, we have a documented smoking policy: Select this option if your
    facility has a smoking policy in place. The system will record your
    confirmation.
  </goab-text>

  <goab-text tag="p" size="body-m" mt="xl" mb="l">
    No, we don't have a smoking policy, but we are creating one: Select this
    option if your facility does not yet have a smoking policy. You should
    continue selecting No each week until a smoking policy is in place for your
    facility.
  </goab-text>

  <goab-text tag="h2" size="heading-xs" mt="xl" mb="xs">
    Changing a previous response
  </goab-text>

  <goab-text tag="span" size="body-m" mt="none" mb="l">
    If you need to change your response from Yes back to No, please email
    <a
      class="smoking-policy__email-link"
      href="mailto:alss.alacapacity@gov.ab.ca"
    >
      alss.alacapacity&#64;gov.ab.ca
      <goab-icon type="open" size="small" [opacity]="1"></goab-icon>
    </a>
    with your facility name and reason for the change.
  </goab-text>

  <goab-text tag="h2" size="heading-xs" mt="l" mb="xs">Note: </goab-text>

  <ul class="smoking-policy__notes" data-testid="smoking-policy-note-list">
    <li>
      <goab-text tag="span" size="body-m" mt="none" mb="none">
        If your policy changes during the week, update it in your next weekly
        report.
      </goab-text>
    </li>
    <li>
      <goab-text tag="span" size="body-m" mt="none" mb="none">
        Keep a copy of your policy handy in case it is requested for
        verification.
      </goab-text>
    </li>
  </ul>
</section>
